module.exports = __webpack_public_path__ + "static/media/defaultDetailPageLogo.e574ab01.png";